import calendarsController from './calendarsController'

export default calendarsController



// WEBPACK FOOTER //
// ../src/controllers/calendarsController/index.js